module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5188/images/default-avatar.png"